import Vue from "vue"
import ToastComponent from "./main.vue"
//toast提示
const ToastConstrctor = Vue.extend(ToastComponent);
let instance;
let instances = [];
let seed = 1;

const Toast = function(options, type){
    if(options == 'hideLoading'){//旧代码兼容
        loadingRemove()
        return;
    }
    if(!options && !type){
        options = {};
    }
    if (typeof options === 'string') {
        options = {
            message: options,
            type
        };
    }
    let userOnClose = options.onClose;
    let id = 'yd-toast_' + seed++;
  
    options.onClose = function() {
        Toast.close(id, userOnClose);
    };
    instance = new ToastConstrctor({
        data: options
      });
    instance.id = id;
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.visible = true;
    instances.push(instance);
    return instance;
};
  
['success', 'warning', 'error', 'loading'].forEach(type => {
    Toast[type] = (options) => {
        if (typeof options === 'string') {
            return Toast({
                type,
                message: options
            });
        }
        return Toast({
            ...options,
            type
        });
    };
});
  
Toast.close = function(id, userOnClose) {
    let len = instances.length;
    let index = -1;
    for (let i = 0; i < len; i++) {
        if (id === instances[i].id) {
            index = i;
            if (typeof userOnClose === 'function') {
                userOnClose(instances[i]);
            }
            instances.splice(i, 1);
            break;
        }
    }
};
  
Toast.closeAll = function() {
    for (let i = instances.length - 1; i >= 0; i--) {
        instances[i].close();
    }
};
function loadingRemove(){//旧代码兼容
    for (let i = instances.length - 1; i >= 0; i--) {
        if(instances[i].type == 'loading'){
            instances[i].close();
            break;
        }
    }
}
export default Toast;